exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orders-export-dialog{width:500px}.orders-export-dialog h6{margin-top:1.5rem;margin-bottom:0}.orders-export-dialog .questions-container label{cursor:pointer}.orders-export-dialog .questions-container .format-row label{min-width:100px;padding-left:10px;margin-left:-10px}.orders-export-dialog .questions-container .label{font-weight:normal}.orders-export-dialog .questions-container .selected .label{font-weight:bold}.orders-export-dialog .format-row{display:flex;flex-direction:row}.orders-export-dialog .buttons-container{font-size:.875em;display:flex;justify-content:flex-end;align-items:center;margin-top:2.5em;gap:1em}", ""]);

// exports
